module.exports = __webpack_public_path__ + "img/percentage.d78d4fca.svg";